/* Month attendance calendar (prototype monthGrid) driven by /attendance/month data. */
import type { DailyAttendance } from "../../../data/types";
import { useI18n } from "../../../i18n";

const WD_EN = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const WD_AR = ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];
const CLS: Record<string, string> = { Present: "present", Late: "late", Absent: "absent", Weekend: "weekend", "On leave": "leave", "Missing punch": "late", "Not in yet": "future" };

export default function MonthGrid({ period, rows, today, weekendDays }: { period: string; rows: DailyAttendance[]; today: string; weekendDays: number[] }) {
  const { t, L } = useI18n();
  const [y, m] = period.split("-").map(Number);
  const first = new Date(Date.UTC(y, m - 1, 1)).getUTCDay();
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const by = new Map(rows.map((r) => [r.date, r]));
  const cells = [];
  for (let p = 0; p < first; p++) cells.push(<div key={"b" + p} />);
  for (let d = 1; d <= days; d++) {
    const ds = period + "-" + String(d).padStart(2, "0");
    const wd = (first + d - 1) % 7;
    const r = by.get(ds);
    let cls = r ? CLS[r.status] ?? "future" : weekendDays.includes(wd) ? "weekend" : "future";
    if (!r && ds > today && weekendDays.includes(wd)) cls = "weekend";
    const label = !r ? (cls === "weekend" ? t("Weekend") : "")
      : r.status === "Present" ? r.firstIn ?? t("Present")
      : r.status === "Late" ? t("Late") + (r.firstIn ? " " + r.firstIn : "")
      : t(r.status);
    cells.push(
      <div key={ds} className={"day " + cls + (ds === today ? " today" : "")} data-testid={"day-" + ds} data-status={r?.status ?? ""}>
        <b>{d}</b><span>{label}</span>
      </div>,
    );
  }
  return (
    <>
      <div className="month" data-testid="month-grid">
        {WD_EN.map((w, i) => <div key={w} className="mh">{L(w, WD_AR[i])}</div>)}
        {cells}
      </div>
      <div className="legend mt">
        {([["present", "Present", "success"], ["late", "Late", "warning"], ["absent", "Absent", "danger"], ["leave", "On leave", "info"], ["weekend", "Weekend", "border-strong"]] as const).map(([k, l, c]) => (
          <span key={k}><i style={{ background: "var(--" + c + ")" }} />{t(l)}</span>
        ))}
      </div>
    </>
  );
}
